import styled from 'styled-components';

const TableBody = styled.tbody``;

export default TableBody;
